import { __assign } from "tslib";
// DS: P19A
import React from 'react';
import IconWrap from '../IconWrap';
var DeviationTypeFilm = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "none" },
                React.createElement("path", { fill: "#06070D", opacity: ".24", d: "M21 4v15H3V4z" }),
                React.createElement("path", { fill: "#FFF", d: "M20 5v13H4V5h16zM10 9v5l4.4545-2.5L10 9z" })))));
};
DeviationTypeFilm.displayName = 'DeviationTypeFilm';
export default DeviationTypeFilm;
//# sourceMappingURL=Film.js.map